import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import type { Locale } from '../i18n';
import { STRINGS } from '../i18n';

interface HeaderProps {
  locale: Locale;
  onToggleLocale: () => void;
}

export function Header({ locale, onToggleLocale }: HeaderProps) {
  const t = STRINGS[locale];
  return (
    <header className="border-b border-slate-200 bg-white/80 backdrop-blur sticky top-0 z-10">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" aria-label="PocketLedger home">
          <Logo />
        </Link>
        <button
          type="button"
          onClick={onToggleLocale}
          className="rounded-md border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-100"
          aria-label="Toggle language"
        >
          {t.localeToggle}
        </button>
      </div>
    </header>
  );
}
